module.exports = __webpack_public_path__ + "assets/img/logo-desktop-light.d1dbec62.svg";